var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMintcardPositive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 933.11 234.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_25);}.cls-2{fill:url(#Degradado_sin_nombre_34);}.cls-3{fill:#313e56;}.cls-4{fill:url(#Degradado_sin_nombre_23);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25",
    x1: 255.27,
    y1: 55.24,
    x2: 18.72,
    y2: 243.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26449a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#26449a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_34",
    x1: 186.44,
    y1: -22.65,
    x2: -36.4,
    y2: 183.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0080ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_23",
    x1: 310.83,
    y1: 23.96,
    x2: 54.8,
    y2: 187.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.77,209.85H49.49a24.42,24.42,0,0,1-24.39-24.4V41.68a35.58,35.58,0,0,0-25,31.61C0,74.07,0,74.84,0,75.63V199.44a35.55,35.55,0,0,0,35.51,35.5h233c.79,0,1.57,0,2.34-.08a35.6,35.6,0,0,0,31.61-25H271.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.83,45H74.31A10.8,10.8,0,0,0,63.53,55.75V82.27A10.8,10.8,0,0,0,74.31,93.06h26.52a10.8,10.8,0,0,0,10.79-10.79V55.75A10.8,10.8,0,0,0,100.83,45Zm-.41,32.29a4.6,4.6,0,0,1-4.6,4.6H79.32a4.6,4.6,0,0,1-4.6-4.6V60.76a4.6,4.6,0,0,1,4.6-4.6h16.5a4.6,4.6,0,0,1,4.6,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.66,29.82V1.57h33.4V29.82Zm1.57,135.64V41.92h32.28V165.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.45,82.28v83.18H464.39V85.64c0-12.1-4.49-16.81-12.11-16.81-6.73,0-13,5.83-16.37,15.92v80.71H403.85V41.92h32.06v14.8c6.06-10.31,15.47-17.26,28-17.26C484.79,39.46,496.45,53.58,496.45,82.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M515.55,129.81V69.5H504.11V54.26L514.2,41.7l20.4-26.23h13V41.92h26.68V69.5H547.61v57c0,8.07,2.91,12.55,9.64,12.55a39.39,39.39,0,0,0,13.9-3.14l5.15,26.91a75.35,75.35,0,0,1-26.45,5.38C527.65,168.15,515.55,155.59,515.55,129.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M578.43,103.8c0-40.35,20.4-64.34,52.24-64.34a56.58,56.58,0,0,1,27.8,7.17l-7.85,27.58c-6.72-4-11.88-5.61-17.93-5.61-13.45,0-22,11.89-22,35,0,23.31,8.52,35.2,22,35.2a35.6,35.6,0,0,0,18.16-5.16l7.62,27.13c-9.86,5.38-18.61,7.4-27.58,7.4C598.39,168.15,578.43,144.16,578.43,103.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M752.41,87.88v77.58H720.57V150.88c-5.6,11.66-15.47,17.27-27.13,17.27-18.38,0-31.38-13.23-31.38-39.69,0-22.64,11.43-37.89,37.66-37.89a206.71,206.71,0,0,1,20.85,1.13V86.76c0-14.12-6.28-19.73-18.83-19.73a67.87,67.87,0,0,0-26,5.83l-3.36-27.12A86.15,86.15,0,0,1,706,39.23C739,39.23,752.41,57.39,752.41,87.88Zm-31.84,24.44V111a114.58,114.58,0,0,0-13.23-.9c-9.64,0-14.57,5.16-14.57,15.92s4.93,15,11.88,15C714.52,141,720.57,132.05,720.57,112.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M831.37,41.25,828.9,74.43a58.66,58.66,0,0,0-10.76-1.12c-11,0-17.49,11.44-17.49,34.08v58.07H768.37V41.92h32.28v13c5.16-10.76,12.78-15,22-15A31.82,31.82,0,0,1,831.37,41.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M833.57,103.35c0-42.37,15.91-63.89,40.13-63.89,10.09,0,19.95,3.36,27.35,13.45V0h32.06V165.46H901.05V154.69c-7.4,9.87-17.49,13.46-27.8,13.46C849.71,168.15,833.57,146,833.57,103.35Zm67.48,1.35c0-23.54-6.28-36.54-17.94-36.54-9.86,0-16.81,9.86-16.81,35.19,0,26,7,36.1,16.81,36.1C894.32,139.45,901.05,124.88,901.05,104.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.68,52.54a32.1,32.1,0,0,1,26.14-13c13.23,0,22.11,5.67,26.85,17.2a.23.23,0,0,0,.42,0C284.59,46.25,295,39.5,307.77,39.5c15.57,0,25.24,7.67,29.1,23.36a.28.28,0,0,0,.56-.07V23.08A16.34,16.34,0,0,0,321.09,6.74H49.73A16.35,16.35,0,0,0,33.39,23.08V185.21a16.34,16.34,0,0,0,16.34,16.34H321.09a16.33,16.33,0,0,0,16.34-16.34V165.27a.25.25,0,0,0-.24-.25H307.12a.25.25,0,0,1-.24-.25V85.29c0-12.06-4-16.53-10.5-16.53-7.14,0-12.72,5.58-14.73,16.5a.11.11,0,0,0,0,0v79.46a.25.25,0,0,1-.25.25H250a.25.25,0,0,1-.25-.25V85.29c0-12.51-4-16.53-10.27-16.53-7.37,0-13.17,6.25-15.18,18.07a.06.06,0,0,0,0,0v77.9a.25.25,0,0,1-.24.25H192.55a.25.25,0,0,1-.24-.25V42.21a.25.25,0,0,1,.24-.25H224a.25.25,0,0,1,.24.25V52.4A.24.24,0,0,0,224.68,52.54ZM117.62,82.27a16.8,16.8,0,0,1-16.78,16.79H74.32A16.37,16.37,0,0,1,72.6,99a16.81,16.81,0,0,1-15.07-16.7V55.75A16.8,16.8,0,0,1,74.31,39h26.53a16.8,16.8,0,0,1,16.78,16.78Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintcardPositive);
export default __webpack_public_path__ + "static/media/Mintcard-Positive.b39401e918d67b0ca818b4039d2b247b.svg";
export { ForwardRef as ReactComponent };